import styled from "styled-components";
import { Form, Radio, Card, Input, Divider, Select, Modal } from "antd";

export const Body = styled.div`
  align-items: center;
  color: rgb(181 175 195);
  // display: flex;
  flex-direction: column;
  font-size: calc(10px + 2vmin);
  justify-content: center;

  background: transparent;
  // background: linear-gradient(
  //   76.8deg,
  //   rgb(121, 45, 129) 3.6%,
  //   rgb(36, 31, 98) 90.4%
  // );
  min-height: 100vh;
  max-height: 150vh;
  background-attachment: fixed;
  // overflow: hidden;
`;
export const Container = styled.div`
  // display: flex;
  // flex-direction: column;
  // background: linear-gradient(
  //   89.7deg,
  //   rgb(0, 32, 95) 2.8%,
  //   rgb(132, 53, 142) 97.8%
  // );
  // overflow: hidden;

  background: -webkit-linear-gradient(
    225deg,
    hsla(216, 90%, 12%, 1) 0%,
    hsl(225deg 63% 8%) 40%,
    hsla(273, 45%, 20%, 1) 100%
  );
  // background: linear-gradient(
  //   76.8deg,
  //   rgb(121, 45, 129) 3.6%,
  //   rgb(36, 31, 98) 90.4%
  // );
  min-height: 100vh;
  height: 150vh;
  background-attachment: fixed;
  // background: hsla(252, 40%, 29%, 1);

  // background: hsla(277, 52%, 60%, 1);

  // background: linear-gradient(
  //   225deg,
  //   hsla(277, 52%, 60%, 1) 0%,
  //   hsla(274, 39%, 41%, 1) 29%,
  //   hsla(263, 53%, 17%, 1) 100%
  // );

  // background: -moz-linear-gradient(
  //   225deg,
  //   hsla(277, 52%, 60%, 1) 0%,
  //   hsla(274, 39%, 41%, 1) 29%,
  //   hsla(263, 53%, 17%, 1) 100%
  // );

  // background: -webkit-linear-gradient(
  //   225deg,
  //   hsla(277, 52%, 60%, 1) 0%,
  //   hsla(274, 39%, 41%, 1) 29%,
  //   hsla(263, 53%, 17%, 1) 100%
  // );

  // filter: progid: DXImageTransform.Microsoft.gradient( startColorstr="#A665CE", endColorstr="#6E3F91", GradientType=1 );
`;

export const Button = styled.button`
  // background-color: #111111;
  // background: -webkit-linear-gradient(
  //   225deg,
  //   hsla(277, 79%, 84%, 1) 0%,
  //   hsla(204, 95%, 77%, 1) 100%
  // );
  background: -webkit-linear-gradient(
    180deg,
    hsla(248, 56%, 55%, 1) 0%,
    hsla(289, 33%, 44%, 1) 100%
  );
  border: none;
  border-radius: 16px;
  color: white;
  cursor: pointer;
  font-size: 16px;
  font-width: 700;
  margin: 0px 20px;
  padding: 12px 24px;
  text-align: center;
  text-decoration: none;
`;
export const EpochButton = styled.button`
  background-color: #111111;
  // background: -webkit-linear-gradient(
  //   225deg,
  //   hsla(277, 79%, 84%, 1) 0%,
  //   hsla(204, 95%, 77%, 1) 100%
  // );
  border: none;
  border-radius: 16px;
  color: rgb(181 175 195);
  cursor: pointer;
  font-size: 16px;
  margin: 0px 20px;
  padding: 12px 24px;
  text-align: center;
  text-decoration: none;
`;

export const FunctionButton = styled.button`
  background: #030000;
  // background: hsla(277, 79%, 84%, 1);
  // background: linear-gradient(
  //   225deg,
  //   hsla(277, 79%, 84%, 1) 0%,
  //   hsla(204, 95%, 77%, 1) 100%
  // );
  // background: -moz-linear-gradient(
  //   225eg,
  //   hsla(277, 79%, 84%, 1) 0%,
  //   hsla(204, 95%, 77%, 1) 100%
  // );
  // background: -webkit-linear-gradient(
  //   225deg,
  //   hsla(277, 79%, 84%, 1) 0%,
  //   hsla(204, 95%, 77%, 1) 100%
  // );
  // filter: progid: DXImageTransform.Microsoft.gradient( startColorstr="#DDB4F6", endColorstr="#8DD0FC", GradientType=1 );
  border: none;
  border-radius: 20px;
  cursor: pointer;
  font-size: 5px;
  width: auto;
  display: flex;
  height: 2rem;
  padding: 4px 11px;
  text-align: center;
  text-decoration: none;
`;

export const ContractButton = styled.button`
  background: #030000;
  // background: hsla(277, 79%, 84%, 1);
  // background: linear-gradient(
  //   225deg,
  //   hsla(277, 79%, 84%, 1) 0%,
  //   hsla(204, 95%, 77%, 1) 100%
  // );
  // background: -moz-linear-gradient(
  //   225eg,
  //   hsla(277, 79%, 84%, 1) 0%,
  //   hsla(204, 95%, 77%, 1) 100%
  // );
  // background: -webkit-linear-gradient(
  //   225deg,
  //   hsla(277, 79%, 84%, 1) 0%,
  //   hsla(204, 95%, 77%, 1) 100%
  // );
  // filter: progid: DXImageTransform.Microsoft.gradient( startColorstr="#DDB4F6", endColorstr="#8DD0FC", GradientType=1 );
  border: none;
  border-radius: 20px;
  cursor: pointer;
  font-size: 5px;
  width: auto;
  display: flex;
  height: 2rem;
  padding: 4px 11px;
  text-align: center;
  text-decoration: none;
  color: white;
`;
export const ButtonSpan = styled.span`
  font-size: 14px;

  background: -webkit-linear-gradient(
    180deg,
    hsla(277, 79%, 84%, 1) 0%,
    hsla(204, 95%, 77%, 1) 100%
  );
  -webkit-text-fill-color: transparent;
  background-clip: text;
  -webkit-background-clip: text !important;
  font-weight: 700;
`;

export const CreateCard = styled(Card)`
  background: transparent;
  color: rgb(181 175 195);
  .ant-card-cover {
    justify-content: center;
    display: flex;
    height: 4rem;
  }
  .ant-card-body {
    height: 8rem;
    .ant-card-meta-title {
      color: rgb(181 175 195);
      font-size: 14px;
    }
    .ant-card-meta-description {
      color: rgb(181 175 195);
      font-size: 10px;
    }
  }
  .ant-card-actions {
    border-top: 1px solid #f0f0f0;
    background: transparent;
  }
  .ant-card-actions > li > span a:not(.ant-btn),
  .ant-card-actions > li > span > .anticon {
    color: rgb(181 175 195);
  }
  &:hover {
    border: 1px solid hsla(289, 33%, 44%, 1);
  }
  margin-bottom: 2rem;
  border-radius: 10px;
`;
export const Header = styled.header`
  align-items: center;
  color: rgb(181 175 195);
  display: flex;
  flex-direction: row;
  min-height: 70px;
  position: fixed;
  z-index: ;
  top: 0;
  left: 0;
  right: 0;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
`;

export const Image = styled.img`
  height: 40vmin;
  margin-bottom: 16px;
  pointer-events: none;
`;

export const Link = styled.a.attrs({
  target: "_blank",
  rel: "noopener noreferrer",
})`
  color: #61dafb;
  margin-top: 8px;
`;
export const LogoDiv = styled.div`
  flex-grow: 1;
  margin-left: 1rem;
`;
export const Logo = styled.img`
  width: 10rem;
`;
export const ButtonDiv = styled.div``;
export const ListDiv = styled.div`
  padding: 2rem 2rem 1.5rem 2rem;
  border-radius: 1rem;
  // background: -webkit-linear-gradient(
  //   180deg,
  //   hsla(205, 34%, 40%, 1) 0%, hsla(347, 52%, 36%, 1) 100%);
  // );
  // background: -webkit-linear-gradient(
  //   225deg,
  //   hsla(216, 90%, 12%, 1) 0%,
  //   hsla(225, 48%, 28%, 1) 40%,
  //   hsla(273, 45%, 20%, 1) 100%
  // );
  //
  background: #130e1b;
  // background: #35273f;
  margin-left: 2rem;
  margin-bottom: 2rem;
  width: 40rem;
`;
export const ListTitle = styled.h5`
  color: rgb(181 175 195);
  font-weight: 800;
  font-size: 26px;
`;

export const ModalTitle = styled.h5`
  color: rgb(181 175 195);
  font-weight: 800;
  font-size: 26px;
`;

export const ModalSubTitle = styled.h5`
  color: rgb(181 175 195);
  font-weight: 800;
  font-size: 20px;
`;

export const RadioItem = styled(Radio)`
  color: rgb(181 175 195);
  font-weight: bold;
  font-size: 16px;
`;
export const FormTitle = styled(Form.Item)`
  color: rgb(181 175 195);
  font-weight: bolder;
  font-size: 18px;
  .ant-form-item-label > label {
    color: rgb(181 175 195);
    font-size: 16px;
  }
`;
export const ListSubTitle = styled.span`
  color: rgb(181 175 195);
  font-size: 13px;
  display: flex;
  margin-bottom: 0.5rem;
`;
export const ListSpan = styled.span`
  display: flex;
`;
export const DeadlineSpan = styled.span`
  display: flex;
  font-weight: 700;
  background: -webkit-linear-gradient(
    180deg,
    hsla(248, 56%, 55%, 1) 0%,
    hsla(289, 33%, 44%, 1) 100%
  );
  -webkit-text-fill-color: transparent;
  background-clip: text;
  -webkit-background-clip: text !important;
`;
export const DeadlineSpanHeading = styled.span`
  display: flex;
  margin-right: 0.25rem;
  font-weight: 700;
  background: -webkit-linear-gradient(
    180deg,
    hsla(248, 56%, 55%, 1) 0%,
    hsla(289, 33%, 44%, 1) 100%
  );
  -webkit-text-fill-color: transparent;
  background-clip: text;
  -webkit-background-clip: text !important;
`;
export const TutorialSubTitle = styled.span`
  color: rgb(181 175 195);
  font-size: 13px;
  display: flex;
  margin-bottom: 1.2rem;
  margin-left: 2rem;
  color: #130e1b;
`;
export const TutorialSpan = styled.span`
  display: flex;
  margin-right: 2rem;
`;
export const TutorialSpanHeading = styled.span`
  display: flex;
  margin-right: 0.25rem;
  flex-grow: 1;
  font-weight: 700;

  // -webkit-text-fill-color: transparent;
  // background-clip: text;
  // -webkit-background-clip: text !important;
`;
export const ListSpanHeading = styled.span`
  display: flex;
  margin-right: 0.25rem;
  // -webkit-text-fill-color: transparent;
  // background-clip: text;
  // -webkit-background-clip: text !important;
`;
export const ListButtonDiv = styled.div`
  display: flex;
  justify-content: end;
  align-items: center;
`;
export const ListHeading = styled.h3`
  color: rgb(181 175 195);
  font-size: 22px;
  font-weight: bolder;
  margin-left: 2.5rem;
`;
export const DocumentationDiv = styled.div`
  display: flex;
  cursor: pointer;
`;
export const ChatDiv = styled.div`
  display: flex;
  margin-left: 2rem;
  cursor: pointer;
`;
export const DocumentationTitle = styled.span`
  font-size: 15px;
  margin-left: 0.25rem;
`;
export const ChatTitle = styled.span`
  font-size: 15px;
  margin-left: 0.25rem;
`;
export const IconDiv = styled.div`
  display: flex;
  margin-left: 2.5rem;
  margin-top: 2rem;
  margin-bottom: 2rem;
`;
export const TutorialDiv = styled.div`
  color: black;
  height: 40rem;
  border-radius: 1rem;
  width: 28rem;
  position: fixed;
  right: 2rem;
  top: 10rem;
  // background: -webkit-linear-gradient(
  //   180deg,
  //   hsla(291, 79%, 51%, 1) 0%,
  //   hsla(240, 91%, 73%, 1) 100%
  // );
  background: -webkit-linear-gradient(
    45deg,
    hsla(11, 82%, 87%, 1) 0%,
    hsla(299, 85%, 90%, 1) 100%
  );

  filter: progid: DXImageTransform.Microsoft.gradient( startColorstr="#F9CDC3", endColorstr="#FACEFB", GradientType=1 );
  // background: hsla(29, 92%, 70%, 1);

  // background: linear-gradient(
  //   90deg,
  //   hsla(29, 92%, 70%, 1) 0%,
  //   hsla(0, 87%, 73%, 1) 100%
  // );

  // background: -moz-linear-gradient(
  //   90deg,
  //   hsla(29, 92%, 70%, 1) 0%,
  //   hsla(0, 87%, 73%, 1) 100%
  // );

  // background: -webkit-linear-gradient(
  //   90deg,
  //   hsla(29, 92%, 70%, 1) 0%,
  //   hsla(0, 87%, 73%, 1) 100%
  // );

  // filter: progid: DXImageTransform.Microsoft.gradient( startColorstr="#F9B16E", endColorstr="#F68080", GradientType=1 );
  // background: hsla(358, 26%, 79%, 1);

  // background: linear-gradient(
  //   90deg,
  //   hsla(358, 26%, 79%, 1) 0%,
  //   hsla(273, 60%, 73%, 1) 50%,
  //   hsla(356, 53%, 57%, 1) 100%
  // );

  // background: -moz-linear-gradient(
  //   90deg,
  //   hsla(358, 26%, 79%, 1) 0%,
  //   hsla(273, 60%, 73%, 1) 50%,
  //   hsla(356, 53%, 57%, 1) 100%
  // );

  // background: -webkit-linear-gradient(
  //   90deg,
  //   hsla(358, 26%, 79%, 1) 0%,
  //   hsla(273, 60%, 73%, 1) 50%,
  //   hsla(356, 53%, 57%, 1) 100%
  // );

  // filter: progid: DXImageTransform.Microsoft.gradient( startColorstr="#D8BDBE", endColorstr="#BD90E3", GradientType=1 );
  margin-left: 1rem;
`;
export const CreateButton = styled.button`
  width: 11rem;
  background: -webkit-linear-gradient(
    180deg,
    hsla(248, 56%, 55%, 1) 0%,
    hsla(289, 33%, 44%, 1) 100%
  );
  border: none;
  border-radius: 16px;
  color: white;
  cursor: pointer;
  font-size: 16px;
  // margin: 0px 20px;
  padding: 12px 24px;
  text-align: center;
  text-decoration: none;
`;
export const NavDiv = styled.div`
  // margin-left: 1.2rem;
  margin-top: 2rem;
  background: #130e1b;
  padding: 1rem 0rem 0.2rem 2rem;
  border-radius: 1rem;
  width: 11rem;
`;
export const NavSpan = styled.span`
  display: flex;
  font-size: 15px;
  margin-bottom: 1.5rem;
  background: -webkit-linear-gradient(
    180deg,
    hsla(248, 56%, 55%, 1) 0%,
    hsla(289, 33%, 44%, 1) 100%
  );
  filter: progid: DXImageTransform.Microsoft.gradient( startColorstr="#5C73B9", endColorstr="#B330E1", GradientType=1 );
  -webkit-text-fill-color: transparent;
  background-clip: text;
  -webkit-background-clip: text !important;
  font-weight: 800;
  cursor: pointer;
  &:hover {
    background: -webkit-linear-gradient(
      180deg,
      hsla(277, 79%, 84%, 1) 0%,
      hsla(204, 95%, 77%, 1) 100%
    );
  }
`;
export const EthImage = styled.svg`
  width: 4rem;
  display: flex;
  margin-left: 2rem;
  margin-bottom: 2rem;
  cursor: pointer;
`;
export const NewImage = styled.img`
  width: 1.4rem;
  display: flex;
  margin-left: 3rem;
  margin-bottom: 3.5rem;
  cursor: pointer;
`;
export const SideDiv = styled.div`
  position: fixed;
  top: 10rem;
`;
export const FormInput = styled(Input)`
  border: 1px solid white;
  border-radius: 6px;
  background: transparent;
  color: rgb(181 175 195);
  height: 2.5rem;
`;
export const FormSelect = styled(Select)`
  height: 2.5rem;
  &.ant-select {
    border: 1px solid white;
    border-radius: 6px;
    background: transparent !important;
    color: rgb(181 175 195);
    &.ant-select-arrow {
      color: white !important;
    }
  }
  &.ant-select:not(.ant-select-customize-input) .ant-select-selector {
    border: 1px solid transparent;
    background: transparent !important;
    color: rgb(181 175 195);
    height: 2.5rem;
    border-radius: 6px;
  }
  .ant-select-item-option-active:not(.ant-select-item-option-disabled) {
    background-color: #130e1b;
  }
`;
export const SelectOption = styled(Select.Option)`
  border: 1px solid white;
  border-radius: 6px;
  background: transparent;
  color: rgb(181 175 195);
  height: 2.5rem;
  &.ant-select-arrow {
    color: white !important;
  }
  &.ant-form-item-control-input {
    width: 22.7rem;
    margin-left: 2.8rem;
  }
  &.ant-select-dropdown ant-select-dropdown-placement-bottomLeft {
    background-color: transparent !important;
    height: 100%;
    border-radius: 6px;
    height: 2.5rem;
  }
  .ant-select-item-option-active:not(.ant-select-item-option-disabled) {
    background-color: #130e1b;
  }
`;
export const ModalOption = styled(Select.Option)`
  border: 1px solid white;
  border-radius: 6px;
  background: transparent;
  color: rgb(181 175 195);
  height: 2.5rem;
  &.ant-form-item-control-input {
    width: 22.7rem;
    margin-left: 2.8rem;
  }
  &.ant-select-dropdown ant-select-dropdown-placement-bottomLeft {
    background-color: transparent !important;
    height: 100%;
    border-radius: 6px;
    height: 2.5rem;
  }
  .ant-select-item-option-active:not(.ant-select-item-option-disabled) {
    background-color: #130e1b;
  }
`;

export const MainDiv = styled.div`
  position: relative;
  top: 10rem;
  overflow: auto;
`;
export const NavMainDiv = styled.div`
  position: fixed;
  top: 10rem;
  margin-left: -1rem;
`;
export const ListDivider = styled(Divider)`
  border-color: #2d2c32;
  border-width: 0.1px;
`;
export const ListJob = styled.div`
  cursor: pointer;
`;
export const MainModal = styled(Modal)`
  position: absolute;
  transform: translate(-50%, -50%);
  top: 50%;
  left: 50%;
  &.ant-modal-mask {
    backdrop-filter: blur(1px);
  }
  &.ant-modal-wrap {
    &.ant-modal {
      background: #130e1b;
      &.ant-modal-content {
        background: #130e1b !important;
        &.ant-modal-header {
          background: #130e1b !important;
        }
      }
    }
  }
  &.ant-modal-content {
    background: #130e1b !important;
  }
`;
export const TutorialButtondiv = styled.div`
  display: flex;
  bottom: 1.5rem;
  right: 1rem;
  left: 0.5rem;
  position: absolute;
`;
export const TutorialImage = styled.img`
  width: 26rem;
  margin-left: 1rem;
  height: auto;
  margin-top: 7rem;
`;
